import { useEffect } from "react";

import { useCustomSearchParams } from "../../../hooks/useCustomSearchParams";

export function useBoardViewParams() {
  const [milestone] = useCustomSearchParams("milestone");
  const [worklogs, setWorklogs] = useCustomSearchParams("worklogs");
  const [gantChart] = useCustomSearchParams("GantChart");
  const [quickTasks] = useCustomSearchParams("quickTasks");

  useEffect(() => {
    if (worklogs === null) {
      setWorklogs("worklogs", "false");
    }
  }, [setWorklogs, worklogs]);


  return {
    isMilestoneView: Boolean(milestone),
    isWorklogView: worklogs === "true",
    isGanttChartView: gantChart === "true",
    includeQuickTasks: quickTasks !== "false",
  };
}
